import { motion } from "framer-motion";

export const PageHero = ({ eyebrow, title, description, image, imageAlt, testId }) => (
  <section data-testid={testId} className="relative overflow-hidden px-4 pb-20 pt-36 sm:px-8 lg:px-10 lg:pb-28">
    <div className="absolute inset-0 hero-grid opacity-50" aria-hidden="true" />
    <div className="absolute -right-32 top-16 h-80 w-80 rounded-full bg-blue-500/20 blur-3xl" aria-hidden="true" />
    <div className="relative mx-auto grid max-w-7xl items-end gap-12 lg:grid-cols-[1.1fr_.9fr]">
      <motion.div initial={{ opacity: 0, y: 34 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}>
        <p className="font-mono text-xs uppercase tracking-[0.32em] text-amber-400">{eyebrow}</p>
        <h1 className="mt-5 max-w-4xl font-heading text-4xl font-bold tracking-tight text-white sm:text-6xl lg:text-7xl">{title}</h1>
        <p className="mt-6 max-w-2xl text-base leading-8 text-slate-300 sm:text-lg">{description}</p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, x: 40, rotate: 2 }}
        animate={{ opacity: 1, x: 0, rotate: 0 }}
        transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        className="spotlight clip-frame relative h-72 overflow-hidden border border-white/10 sm:h-96"
      >
        <img src={image} alt={imageAlt} className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#070C14]/70 via-transparent to-transparent" />
      </motion.div>
    </div>
  </section>
);
